<div
  class="patient-overview-frame"
  [class.fullscreen]="vm.isImageShareMode">
  <app-window-title
    [closable]="true"
    [title]="'Patient Overview'"
    (closed)="onClose()"></app-window-title>

  <div
    class="patient-info-section"
    [class.split-mode]="vm.isImageShareMode">
    <div class="patient-info-left">
      <!-- Basic patient information — hidden when studies results span multiple patients -->
      <app-patient-basic-info
        *ngIf="!studiesHaveMultiplePatients"
        [compact]="vm.isImageShareMode"
        [patient]="studiesFoundPatient || vm.patient">
      </app-patient-basic-info>

      <!-- Patient IDs remains full width -->
      <!-- <div class="info-field">
        <div class="field-value">
          <app-patient-ids class="patient-ids-full-width"
                           [currentFacility]="vm.currentFacility"
                           [patientIDs]="vm.patient?.patientIDs"
                           [resetToken]="vm.patientIdsResetToken"
                           (selectedPatientIdEvent)="onSelectedPatientIdEvent($event)"></app-patient-ids>
        </div>
      </div> -->

      <!-- Transfer Visualization in fullscreen mode -->
      <div
        *ngIf="vm.isImageShareMode && vm.selectedTargetFacility"
        class="transfer-visualization-fullscreen">
        <app-transfer-visualization
          [destinationFacility]="destinationFacility"
          [exchangeMode]="exchangeMode"
          [facilitators]="facilitators"
          [sourceFacility]="sourceFacility">
        </app-transfer-visualization>
      </div>

      <app-send-instructions
        *ngIf="shouldShowSendInstructions"
        [caseName]="vm.patient?.caseName"
        [facilitators]="facilitators"
        [patientId]="vm.patient?.patientId"
        [senderFacility]="vm.currentFacility"
        [targetFacility]="vm.selectedTargetFacility?.facility">
      </app-send-instructions>

      <app-retrieve-instructions
        *ngIf="shouldShowRetrieveInstructions"
        [caseName]="vm.patient?.caseName"
        [facilitators]="facilitators"
        [patientId]="vm.patient?.patientId"
        [senderFacility]="vm.currentFacility"
        [targetFacility]="vm.selectedTargetFacility?.facility">
      </app-retrieve-instructions>
    </div>

    <div
      *ngIf="!vm.isImageShareMode"
      class="patient-info-right">
      <div class="patient-picture-section">
        <div class="picture-placeholder">
          <img
            *ngIf="vm.patient?.patientPicture"
            class="patient-image"
            alt="Patient Picture"
            [src]="vm.patient.patientPicture" />
          <div
            *ngIf="!vm.patient?.patientPicture"
            class="no-image">
            <mat-icon> person </mat-icon>
            <span> PATIENT PICTURE </span>
          </div>
        </div>
      </div>
    </div>

    <div
      *ngIf="vm.isImageShareMode"
      #imageShareRight
      class="image-share-right">
      <div
        *ngIf="activeImageShareTitle"
        class="image-share-header">
        {{ activeImageShareTitle }}
      </div>
      <div
        *ngIf="vm.activeImageShareTab === 'studies'"
        class="studies-container"
        style="height: calc(100% - 45px); width: 100%; overflow: hidden">
        <app-studies-page [orthancUrl]="vm.getOrthanC_URL()"
                          [patientCaseName]="vm.patient?.caseName"
                          [exchangeAction]="vm.shareDirection === 'send' ? 'SEND' : (vm.shareDirection === 'receive' ? 'RETRIEVE' : null)"
                          [targetFacilityId]="vm.selectedTargetFacility?.facility"
                          [senderFacilityId]="vm.currentFacility"
                          (studiesChanged)="onStudiesChanged($event)"></app-studies-page>
      </div>

      <div
        *ngIf="vm.activeImageShareTab !== 'studies'"
        class="image-share-iframe-container">
        <div
          *ngIf="vm.isIframeLoading"
          class="iframe-loading">
          Loading...
        </div>
        <div
          *ngIf="vm.iframeError"
          class="iframe-error"
          style="padding: 20px; color: red">
          <strong> Error: </strong>
          {{ vm.iframeError }}
        </div>
        <iframe
          *ngIf="vm.selectedImageShareUrl && !vm.iframeError"
          #orthancFrame
          class="image-share-frame"
          frameborder="0"
          referrerpolicy="same-origin"
          [src]="vm.selectedImageShareUrl | safe"
          [title]="activeImageShareTitle"
          (error)="onIframeError()"
          (load)="onIframeLoaded()"></iframe>
      </div>
    </div>
  </div>
</div>

<!-- Decision Screen -->
<div
  *ngIf="vm.showDecisionScreen"
  class="decision-screen">
  <div class="decision-buttons">
    <button
      class="decision-button"
      type="button"
      mat-stroked-button
      [disabled]="true">
      <mat-icon> person </mat-icon>
      <span> View Patient Profile </span>
    </button>

    <button
      class="decision-button"
      type="button"
      mat-stroked-button
      [disabled]="true">
      <mat-icon> folder </mat-icon>
      <span> Manage Patient Library </span>
    </button>

    <button
      class="decision-button decision-button-active"
      type="button"
      mat-stroked-button
      (click)="onDecisionSelected('exchange')">
      <mat-icon> swap_horiz </mat-icon>
      <span> Images and Documents Exchange </span>
    </button>
  </div>
</div>

<h3
  *ngIf="vm.optionSelected"
  class="option-selected-title"
  style="
    text-align: center;
    margin-top: 20px;
    margin-bottom: 20px;
    background-color: #f0f0f0;
    padding: 10px;
    border-radius: 5px;
    font-size: 1.2rem;
    font-weight: bold;
    border: 1px solid #ccc;
  ">
  {{ vm.getOptionSelectedTitle() }}
</h3>

<!-- Back to Patients List Button - Show when decision screen is visible -->
<div
  *ngIf="vm.showDecisionScreen"
  class="back-to-patients-container">
  <button
    class="back-to-patients-button"
    type="button"
    mat-stroked-button
    (click)="onBackToPatientsList()">
    <mat-icon> list </mat-icon>
    <span> Back to Patients List </span>
  </button>
</div>

<!-- Transfer Visualization - Show after Step 1 (target facility selected) - only in normal view -->
<app-transfer-visualization
  *ngIf="vm.selectedTargetFacility && !vm.isImageShareMode && vm.showSharingSetup"
  [destinationFacility]="destinationFacility"
  [exchangeMode]="exchangeMode"
  [facilitators]="facilitators"
  [sourceFacility]="sourceFacility">
</app-transfer-visualization>
